import alertService from './alertService';
import bsStateValidator from './bsStateValidator';
import messageService from './messageService';
import extraTranslationsServices from './extraTranslationsServices';
import permissions from './permissions';

export default {
  install(Vue) {
    Vue.use(alertService);
    Vue.use(bsStateValidator);
    Vue.use(messageService);
    Vue.use(extraTranslationsServices);
    Vue.use(permissions);
  },
};
